export default {

  headline: 'SIEGENIA Mediacenter',
  search_info: 'Znajdź na stronie',
  back: 'wróć',
  no_results: ' Podana fraza nie została znaleziona. Sprawdź poprawność wpisanej frazy. ',
  service: {
    downloads: 'Dokumenty',
    videos: 'Wideo',
    faq: 'FAQ'
  },
  service_search: {
    category_placeholder: "Filtr według kategorii"
  },
  service_download: {
    select_info: 'Wybierz obszar wyszukiwania',
    select_productgroup: 'Wybierz Grupę Produktową',
    select_product: 'Wybierz Produkt',
    select_type: 'Wybierz Kategorię',
    option_language: "język",
    types: {
      tec_info: 'Informacje techniczne',
      installation: 'Instrukcje okuwania/montażu',
      planning: 'Dokumenty planistyczne',
      catalog: 'Prospekty',
      order_forms: 'Formularze zamówieniowe',
      maintenance: 'Konserwacja, eksploatacja, czyszczenie',
      construction_drawings: 'Rysunki konstrukcyjne',
      software: 'Oprogramowanie',
      certificate: 'Certyfikaty i wytyczne',
      press: 'Prasa & dokumenty marketingowe',
      videos: 'Video',
      undefined: 'Pozostałe',
      commercial: 'Spot reklamowy',
      product_video: 'Film produktowy',
      operating: 'Obsługa',
      'function': 'Funkcjonowanie',
      'assembly': 'Okuwanie',
      'installation_video': 'Instalacja / Montaż',
      'assembly_instructions': 'instrukcja okuwania',
      'brochure': 'Broszura',
      'tec_catalog': 'Katalogi techniczne',
      'tec_sheet': 'Karty danych technicznych',
      'usage_charts': 'Schematy zastosowań',
      'profile_sheet': 'Arkusze danych profilowych',
      'operations_manual': 'Instrukcja obsługi i konserwacji',
      hardware_info: 'Informacje dotyczące montażu',
      'installation_suggestion' : 'Propozycja instalacji',
      'general' : 'Generał',
      'troubleshooting' : 'Rozwiązywanie problemów',
      "smarthome:general" : 'Generał',
      'smarthome:installation' : 'Instalacja',
      'smarthome:troubleshooting' : 'Rozwiązywanie problemów',
      'smarthome:startup' : 'Uruchomienie',
      'smarthome:operating' : 'Instrukcja obsługi',
      'order' : 'Zamówienie',
    },
    filter_sorting: {
      filter: "Filtruj",
      sorting: "Sortuj",
      asc: "Tytuł wznoszący (A-Z)",
      desc: "Tytuł zstępujący (Z-A)",
      date_asc: "Data najstarsza pierwsza",
      date_desc: "Data najnowsza pierwsza",
      relevance: "Według ważności",
      facet_headline: "Filtruj wyniki wyszukiwania",
      facet_filter_lang: "Języki",
      facet_filter_level_0: "Kategoria",
      facet_filter_type_id: "Rodzaj",
      filter_remove: "Reset filter",
      show_hide: "Display filter",
    },
    result: {
      count_media: "Znaleziono",
      show_results: "Pokaż",
      preview_type_catalog: "HTML",
      lang_not_available: "Aktualnie brak wybranej wersji językowej",
      version_info: "Ten link prowadzi do najnowszej wersji dokumentacji. Jeśli potrzebują Państwo starszej wersji, prosimy o kontakt z doradcą klienta SIEGENIA."
    }
  }

};
